import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { initValueLead } from '../../shared/initials';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import { fetchDataAndUpdateStore, singleRowAddUpdateInStore } from '../../redux/actions';
import LeadForm from './leadForm';
import { validationSchemaLead } from './validationSchema';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import { getGridDataByModuleKey, getUser } from '../../redux/selector';
import { dropdownPayload } from '../../shared/constants';
import cancel from '../../../src/assets/img/crm_home/header/cancel.png';
import save from '../../../src/assets/img/crm_home/header/save.png';
const AddLead = (props) => {
  const gridData = useSelector(getGridDataByModuleKey('leads'));
  const handleCloseAddForm = () => {
    if (formData.from === 'view') {
      navigate(`/leads/viewLead?id=${formData.id}&pageNo=${gridData?.inputPayload?.pageNumber}`);
    } else {
      navigate('/leads');
    }
  };
  const stateData = useSelector((state) => state);
  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(
    stateData,
    'revenueTypeList',
    'leadSourceList',
    'industryList',
    'timeZone'
  );

  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector(getUser);
  // Update owner in initValueLead if it is an empty string
  if (!initValueLead.owner) {
    initValueLead.owner = userInfo?.user?.display_name;
    initValueLead.ownerId = userInfo?.user?.userId;
  }
  const [loading, setLoading] = useState(storeLoading);
  const [formData, setFormData] = useState(initValueLead);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [imagefile, setImageFile] = useState(null);

  const handleUploadImage = async (imagefile) => {
    setImageFile(imagefile);
    setFormEdited(true);
  };

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    let convertedValue = value;

    // For phone-related fields: Allow only numbers, +, -, parentheses, and spaces
    if (['phone', 'mobile', 'alternatePhone', 'directPhone'].includes(name)) {
      convertedValue = value.replace(/[^0-9+\-() ]/g, '');
    }

    // Employees: allow only digits and convert to int, or null if empty
    if (name === 'noOfEmployees') {
      if (value.trim() === '') {
        convertedValue = null;
      } else {
        convertedValue = value.replace(/[^0-9]/g, '');
        if (convertedValue !== '') {
          convertedValue = parseInt(convertedValue, 10);
        }
      }
    }

    // For numeric-only fields
    if (['noOfBeds'].includes(name)) {
      convertedValue = value.replace(/[^0-9]/g, '');
    }

    // For annualRevenue and writtenPremium
    if (['annualRevenue', 'writtenPremium'].includes(name)) {
      if (value === '') {
        convertedValue = null; // Send null instead of empty string
      } else {
        let sanitized = value.replace(/[^0-9.]/g, '');

        const parts = sanitized.split('.');
        if (parts.length > 2) {
          sanitized = parts[0] + '.' + parts[1];
        }

        if (parts.length === 2) {
          parts[1] = parts[1].slice(0, 2);
          sanitized = parts[0] + '.' + parts[1];
        }

        const parsed = parseFloat(sanitized);
        convertedValue = !isNaN(parsed) && /^\d+(\.\d{1,2})?$/.test(sanitized) ? parsed : sanitized;
      }
    }

    // Clear the error for this field
    setErrorMsg((prev) => ({
      ...prev,
      [name]: undefined,
    }));

    // Update form data
    setFormData((prev) => ({
      ...prev,
      [name]: convertedValue,
    }));

    setFormEdited(true);
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };
  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    if (name === 'revenueTypeId') {
      setFormData({
        ...formData,
        revenueTypeId: selectedId,
        revenueType: selectedValue,
      });

      setFormEdited(true);
    } else if (name === 'leadSourceId') {
      setFormData({
        ...formData,
        leadSourceId: selectedId,
        leadSource: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'industryId') {
      setFormData({
        ...formData,
        industryId: selectedId,
        industry: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'ownerId') {
      setFormData({
        ...formData,
        ownerId: selectedId,
        owner: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'timeZoneId') {
      setFormData({
        ...formData,
        timeZoneId: selectedId,
        timeZone: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'salutationId') {
      setFormData({
        ...formData,
        salutationId: selectedId,
        salutation: selectedValue,
      });
      setFormEdited(true);
    }
  };

  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target; // Use 'checked' for true/false value
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set the checkbox state as true/false
    }));
    setFormEdited(true);
  };

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      // Remove "https://" and "www." from relevant fields
      const sanitizedData = {
        ...formData,
        website: formData?.website?.replace(/^(https?:\/\/)?(www\.)?/, ''), // Remove protocol and www from website
        contactLinkedIn: formData?.contactLinkedIn?.replace(/^(https?:\/\/)?(www\.)?/, ''), // Remove protocol and www from contactLinkedIn
        companyLinkedIn: formData?.companyLinkedIn?.replace(/^(https?:\/\/)?(www\.)?/, ''), // Remove protocol and www from companyLinkedIn
      };

      await validationSchemaLead.validate(sanitizedData, { abortEarly: false });
      handleFormSubmit(sanitizedData);
    } catch (error) {
      setLoading(false);
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      const errorFields = Object.keys(fieldErrors);
      console.log('text', errorFields);
      if (errorFields.length > 0) {
        const firstErrorKey = errorFields[0];
        const errorRef = refs[firstErrorKey];
        console.log('errorRef', errorRef);
        if (errorRef?.current) {
          errorRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
          errorRef.current.focus();
        }
      } else {
        // Submit the form!
      }

      console.error('Validation Error:', fieldErrors);
    }
  };
  const refs = {
    companyName: useRef(null),
    lastName: useRef(null),
    industryId: useRef(null),
    leadSourceId: useRef(null),
    sourceName: useRef(null),
  };
  const updateList = async (msg, id) => {
    setLoading(false);

    toast.success(msg, {
      position: 'top-right',
    });

    const columnName = 'UpdatedDateTime';
    const orderType = 'desc';
    const data = {
      pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
      pageNumber: 1,
      columnName,
      orderType,
      filterJson: null,
    };

    try {
      // ✅ Await the dispatch before navigation
      // await dispatch(
      //   fetchDataAndUpdateStore({ key: "leads", inputData: data })
      // );
      dispatch(
        singleRowAddUpdateInStore({
          moduleName: 'Lead',
          id: formData.type === 'add' ? id : formData.id,
          rowIndex: formData.rowIndex,
        })
      );
      dispatch(
        fetchDataAndUpdateStore({
          key: 'leadDropdown',
          inputData: dropdownPayload,
        })
      );
      if (formData.from === 'view') {
        navigate(`/leads/viewLead?id=${formData.id}&pageNo=${gridData?.inputPayload?.pageNumber}`);
      } else {
        navigate('/leads');
      }
    } catch (error) {
      console.error('Failed to fetch and update leads:', error);
      toast.error('Something went wrong while updating the list.', {
        position: 'top-right',
      });
    }
  };

  const saveUploadImage = async (id) => {
    if (imagefile && id) {
      const newFile = new File([imagefile], id.data, {
        type: imagefile.type,
      });
      let status = await apiServices.uploadLeadImageCRM(newFile, 'Lead');
    }
  };

  const editUploadImage = async (id) => {
    if (imagefile && id) {
      const newFile = new File([imagefile], id, {
        type: imagefile.type,
      });
      let status = await apiServices.uploadLeadImageCRM(newFile, 'Lead');
    }
  };

  const handleFormSubmit = (formData) => {
    if (formData.type === 'add') {
      apiServices
        .createLead(formData)
        .then((response) => {
          if (response.status === 200) {
            const id = response.data;
            saveUploadImage(response);
            updateList('Lead created successfully!', id);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    } else {
      editUploadImage(formData.id);
      apiServices
        .updateLead(formData)
        .then((response) => {
          if (response.status === 200) {
            updateList('Lead updated successfully!');
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    }
  };
  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    let updatedFormData = {
      ...formData,
      type: location.pathname.includes('CreateNew') ? 'add' : 'edit',
    };
    if (location.pathname.includes('editLead') && location.state) {
      updatedFormData = {
        ...location.state,
        type: 'edit',
      };
    }
    setFormData(updatedFormData);
  }, [location]);

  return (
    <div className="addlead_container">
      <div className="viewHeader viewshadow">
        <HeaderProfileBlock
          localData={formData}
          moduleName={'Lead'}
          uploadFile={handleUploadImage}
        />
        <div className="dsk">
          <div className="rightAction">
            <button
              type="button"
              className="btn btn-outline-primary"
              data-bs-dismiss="modal"
              onClick={handleCloseAddForm}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handleSubmit(formData);
              }}
              disabled={loading || (formData.type === 'edit' && !formEdited)}
            >
              {loading && (
                <>
                  {' '}
                  <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                </>
              )}
              {loading ? 'Loading...' : 'Save'}
            </button>
          </div>
        </div>
        <div className="mob">
          <div className="rightAction">
            <button
              type="button"
              className="btn btn-outline-primary"
              data-bs-dismiss="modal"
              onClick={handleCloseAddForm}
            >
              <img src={cancel} alt="Cancel" style={{ width: '12px', height: 'auto' }} />
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handleSubmit(formData);
              }}
              disabled={loading || (formData.type === 'edit' && !formEdited)}
            >
              {loading ? (
                <>
                  {' '}
                  <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                </>
              ) : (
                <img src={save} alt="Save" style={{ width: '13px', height: 'auto' }} />
              )}
            </button>
          </div>
        </div>
      </div>

      <LeadForm
        formData={formData}
        selectedOptions={selectedOptions}
        handleSubmit={handleSubmit}
        handleChangeForm={handleChangeForm}
        handleChangeCheckbox={handleChangeCheckbox}
        handleChange={handleChange}
        errormsg={errormsg}
        refs={refs}
      />
    </div>
  );
};

export default AddLead;
